import { normalizeVector, rotateVector } from "/src/js/engine/utils";
import Entity from "/src/js/engine/entity";
import Explosion from "./explosion";
import Hitbox from "/src/js/engine/hitbox";
import Particle from "./particle";
import CtxTexture from "/src/js/engine/2d/ctxTexture";
import ieURL from "url:/src/img/ie11.png";
import flashURL from "url:/src/img/flash.png";
import xdURL from "url:/src/img/xd.png";
import safariURL from "url:/src/img/safari.png";

export default class Rocket extends Entity{
    constructor({engine, position, player}){
        super({engine,type:"rocket"});
        this.engine = engine;
        this.position = {...position};
        this.direction = {x:0,y:0};
        this.hitbox = new Hitbox({...this.position, w:50, h:50});
        this.player = player;
        this.speed = 1500;
        this.lerp = Math.random() * 0.0025 + 0.0075;
        const urls = [ieURL,flashURL,safariURL,xdURL];
        const url = urls[Math.floor(Math.random() * urls.length)];
        this.texture = new CtxTexture(url);
        this.particleEmissionTimer = 0.2;
        this.lifeTime = 10;
    }

    update(){
        const s =  this.engine.scaleFactor;
        let direction = {x: this.player.position.x - this.position.x, y: this.player.position.y - this.position.y};
        direction = normalizeVector(direction);
        this.direction.x += (direction.x - this.direction.x) * this.lerp;
        this.direction.y += (direction.y - this.direction.y) * this.lerp;
        let angle = Math.atan2(this.direction.y, this.direction.x);

        this.position.x += (this.direction.x * this.speed) * this.engine.time.delta * s;
        this.position.y += (this.direction.y * this.speed) * this.engine.time.delta * s;

        this.particleEmissionTimer -= this.engine.time.delta;
        if(this.particleEmissionTimer <= 0){
            this.particleEmissionTimer = 0.05;
            new Particle({engine:this.engine, position: this.position});
        }
        this.lifeTime -= this.engine.time.delta;
        if(this.lifeTime <= 0){
            this.hit();
        }
    }

    render(ctx){
        const s = this.engine.scaleFactor;
        const w = 50 * s;
        const glowRadius = 50 * s;

        ctx.save();
        ctx.translate(this.position.x, this.position.y);
        ctx.beginPath();

         //light
         const gradient = ctx.createRadialGradient(0, 0, 0, 0, 0, glowRadius);
         gradient.addColorStop(0, 'rgba(255, 0, 0, 0.5)');
         gradient.addColorStop(1, 'rgba(255, 0, 0, 0)');
         ctx.fillStyle = gradient;
         ctx.fillRect(-glowRadius, -glowRadius, glowRadius * 2, glowRadius * 2);

        this.texture.draw(ctx, w);
        ctx.restore();

        this.hitbox.set({...this.position, w, h: w});
    }

    hit(){
        new Explosion({engine: this.engine, position: this.position, size: 600});
        this.engine.destroyEntity(this);
    }

    kill(){
        new Explosion({engine: this.engine, position: this.position, size: 300});
        this.engine.destroyEntity(this);
    }
}